// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('consignmentBatches', {
//         templateUrl: 'views/components/views/consignmentBatches/consignmentBatches.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['consignmentBatchesService', 'cargonizerApiService', function (consignmentBatchesService, cargonizerApiService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let timerCloseBtn = null;

//             vm.model = {
//                 bgShowStatus: {
//                     selected: 'SHOWOPEN',
//                     buttons: [
//                         { id: 'SHOWOPEN', label: 'consignmentbatches_show_open', color: 'primary', onClick: () => vm.model.bgShowStatus.selected = 'SHOWOPEN' },
//                         { id: 'CLOSEOPEN', label: 'consignmentbatches_close_open', color: 'primary', onClick: () => vm.model.bgShowStatus.selected = 'CLOSEOPEN' },
//                         { id: 'CLOSED', label: 'consignmentbatches_closed', color: 'primary', onClick: () => vm.model.bgShowStatus.selected = 'CLOSED' }
//                     ]
//                 },
//                 itemsListBatches: [],
//                 lockedClose: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALL

//             async function loadBatches() {
//                 const itemsListBatches = (await consignmentBatchesService.listBatches({ status: vm.model.bgShowStatus.selected }));

//                 if (vm.model.bgShowStatus.selected !== 'CLOSEOPEN') {
//                     itemsListBatches.forEach((item) => {
//                         vm.model.itemsListBatches.push({
//                             item_id: item.item_id,
//                             item_name: item.item_name,
//                             item_state: item.item_state,
//                             item_path: item.item_path,
//                             item_parms: item.item_parms,
//                             orderby: item.orderby,
//                             badge: item.badge
//                         });
//                     });
//                 } else {
//                     vm.model.itemsListBatches = itemsListBatches;
//                 }
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALL

//             // #region BUTTON RADIO FUNCTIONS

//             vm.selectBgShowStatus = function (value) {
//                 vm.model.bgShowStatus.selected = value;
//                 loadBatches();
//             };

//             // #endregion BUTTON RADIO FUNCTIONS

//             // #region CLOSE BUTTON FUNCTION
            
//             vm.closeBatches = function () {
//                 vm.model.lockedClose = true;

//                 vm.model.itemsListBatches.forEach((item) => {
//                     if (item.item_is_selected !== '0') {
//                         cargonizerApiService.transferCargonizerConsignment(item.item_id).then(() => {
//                             if (timerCloseBtn) clearTimeout(timerCloseBtn);

//                             timerCloseBtn = setTimeout(() => {
//                                 vm.model.lockedClose = false;
//                                 loadBatches();
//                             }, 500);
//                         });
//                     }
//                 });
//             };

//             // #endregion CLOSE BUTTON FUNCTION

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 loadBatches();
//             };

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
